import React from "react";
import { css } from "emotion";
import { NavLink } from "react-router-dom";
import { boxFinishedOffer, boxUnsucccess } from "./style";
import EditOfferRegistered from "./EditOfferRegistered";
import EditInfoRegistered from "./EditInfoRegistered";
import EditInfoFinishedOffer from "./EditInfoFinishedOffer";

import { useNewOffer } from "../../../../../../js/context/new-offer";
import { ROUTE_HOME } from "../../../../../shared/constants";
import { FamilyAccountBanner } from "../../../../../../shared/FamilyAccountBanner/FamilyAccountBanner";

const EditOfferResult = props => {
	const { offerSentStatus } = useNewOffer();

	return offerSentStatus.success ? (
		<div
			className={css`
				${boxFinishedOffer}
			`}
		>
			<FamilyAccountBanner contentType="banner-conta-familia-oferta-cadastrada" />
			<div className="layout--box-offer-registered">
				<EditOfferRegistered typePhoneLatam={props.typePhoneLatam} />
			</div>
			<div className="layout--box-info-registered">
				<EditInfoRegistered typePhoneLatam={props.typePhoneLatam} />
			</div>
			<div className="layout--box-info-finished-offer">
				<EditInfoFinishedOffer typePhoneLatam={props.typePhoneLatam} />
			</div>
		</div>
	) : (
		<div
			className={css`
				${boxUnsucccess}
			`}
		>
			<strong>Não conseguimos concluir sua oferta</strong>
			<span>
				Algo deu errado na hora de cadastrar esta oferta. Tente novamente ou entre em contato com a
				gente.
			</span>
			<NavLink className="btn-secondary-md" to={`${ROUTE_HOME}`} onClick={() => clearContext()}>
				Tentar novamente
			</NavLink>
			<div className="box-companies--none--unsuccess" />
		</div>
	);
};

export default EditOfferResult;
